<ng-container *ngIf="selectedCustomFields?.length">
    <div class="p-field p-grid p-mb-0">
        <ng-container *ngFor="let field of selectedCustomFields; let i = index;">
            <ng-container *ngIf="field.enabledInForm" >
                <ng-container [ngSwitch]="field?.customAttribute?.formControl?.name">

                    <!-- Input Box -->
                    <ng-container *ngSwitchCase="'InputBox'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value" #cinput="ngModel" [ngModelOptions]="{standalone: true}" />

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || cinput.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- AutoNumber -->
                    <ng-container *ngSwitchCase="'AutoNumber'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value" #autoNumber="ngModel" placeholder="This field value will be auto generated" [ngModelOptions]="{standalone: true}" class="p-disabled" [readonly]="true"/>
                        </div>
                    </ng-container>

                    <!-- Multi-Line -->
                    <ng-container *ngSwitchCase="'Multi-Line'">
                        <div class="p-col-12 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <textarea pInputTextarea type="text" rows="5" [(ngModel)]="field.value" #CMultiLine="ngModel" [ngModelOptions]="{standalone: true}" class="w-100"></textarea>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || CMultiLine.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- RichText -->
                    <ng-container *ngSwitchCase="'RichText'">
                        <div class="p-col-12 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-editor #editor [style]="{'height: auto, min-height':'100px'}" [(ngModel)]="field.value" #CRichText="ngModel" [ngModelOptions]="{standalone: true}">
                                <p-header>
                                    <span class="ql-formats">
                                        <select class="ql-size">
                                            <option value="small">small</option>
                                            <option selected></option>
                                            <option value="large">large</option>
                                            <option value="huge">huge</option>
                                        </select>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-bold" aria-label="Bold"></button>
                                        <button class="ql-italic" aria-label="Italic"></button>
                                        <button class="ql-underline" aria-label="Underline"></button>
                                        <button class="ql-strike" aria-label="Strike"></button>
                                    </span>
                                    <span class="ql-formats">
                                        <select title="Text Color" class="ql-color"></select>
                                        <span class="ql-format-separator"></span>
                                        <select title="Background Color" class="ql-background"></select>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-list" value="ordered"></button>
                                        <button class="ql-list" value="bullet"></button>
                                        <select title="Text Alignment" class="ql-align">
                                            <option selected>Gauche</option>
                                            <option value="center" label="Center"></option>
                                            <option value="right" label="Right"></option>
                                            <option value="justify" label="Justify"></option>
                                        </select>
                                    </span>
                                    <span class="ql-formats">
                                        <button aria-label="Link" class="ql-link"></button>
                                    </span>
                                </p-header>
                            </p-editor>
                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || CRichText.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Email -->
                    <ng-container *ngSwitchCase="'Email'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value"
                                ngModel #CEmail="ngModel"
                                [pattern]="field.customAttribute.formControl?.expression"
                                [required]="field.customAttribute?.isRequired"
                                [ngModelOptions]="{standalone: true}"
                            />

                            <ng-container *ngIf="CEmail.touched || isSubmitted">
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CEmail?.errors?.required" [class.details-error]="tabIndex === 1">
                                    {{ field.labelName }} is required
                                </small>
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CEmail?.errors?.pattern" [class.details-error]="tabIndex === 1">
                                    Please enter a valid Email
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- Phone -->
                    <ng-container *ngSwitchCase="'Phone'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value"
                                ngModel #CPhone="ngModel"
                                [pattern]="field.customAttribute.formControl?.expression"
                                [required]="field.customAttribute?.isRequired"
                                [ngModelOptions]="{standalone: true}"
                            />

                            <ng-container *ngIf="CPhone.touched || isSubmitted">
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CPhone?.errors?.required" [class.details-error]="tabIndex === 1">
                                    {{ field.labelName }} is required
                                </small>
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CPhone?.errors?.pattern" [class.details-error]="tabIndex === 1">
                                    Please enter a valid Phone
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- IPAddress -->
                    <ng-container *ngSwitchCase="'IPAddress'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value"
                                ngModel #CIPAddress="ngModel"
                                [pattern]="field.customAttribute.formControl?.expression"
                                [required]="field.customAttribute?.isRequired"
                                [ngModelOptions]="{standalone: true}"
                            />

                            <ng-container *ngIf="CIPAddress.touched || isSubmitted">
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CIPAddress?.errors?.required" [class.details-error]="tabIndex === 1">
                                    {{ field.labelName }} is required
                                </small>
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CIPAddress?.errors?.pattern" [class.details-error]="tabIndex === 1">
                                    Please enter a valid IP Address
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- URL -->
                    <ng-container *ngSwitchCase="'URL'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value"
                                ngModel #curl="ngModel" placeholder="Enter URL with http/https"
                                [pattern]="field.customAttribute.formControl?.expression"
                                [required]="field.customAttribute?.isRequired"
                                [ngModelOptions]="{standalone: true}"
                            />

                            <ng-container *ngIf="curl.touched || isSubmitted">
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="curl?.errors?.required" [class.details-error]="tabIndex === 1">
                                    {{ field.labelName }} is required
                                </small>
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="curl?.errors?.pattern" [class.details-error]="tabIndex === 1">
                                    Please enter a valid URL
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- Barcode -->
                    <ng-container *ngSwitchCase="'Barcode'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="text" [(ngModel)]="field.value" #CBarcode="ngModel" [ngModelOptions]="{standalone: true}" />

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || CBarcode.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- EncryptedText -->
                    <ng-container *ngSwitchCase="'EncryptedText'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-iconField iconPosition="right">
                                <p-inputIcon *ngIf="field?.show" styleClass="pi pi-eye p-mt-1" (click)="field['show']=!field['show']" />
                                <p-inputIcon *ngIf="!field?.show" styleClass="pi pi-eye-slash p-mt-1" (click)="field['show']=!field['show']"/>
                                <input pInputText type="text" [(ngModel)]="field.value"
                                    [style]="!field['show'] ? '-webkit-text-security: disc;':''"
                                    ngModel #CEncryptedText="ngModel"
                                    [pattern]="field.customAttribute.formControl?.expression"
                                    [required]="field.customAttribute?.isRequired"
                                    [showClear]="true"
                                    [ngModelOptions]="{standalone: true}"
                                    (keypress)="clearEncryptedText(field)"
                                />
                            </p-iconField>

                            <ng-container *ngIf="CEncryptedText.touched || isSubmitted">
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CEncryptedText?.errors?.required" [class.details-error]="tabIndex === 1">
                                    {{ field.labelName }} is required
                                </small>
                                <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="CEncryptedText?.errors?.pattern" [class.details-error]="tabIndex === 1">
                                    Encryption text is not valid
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- Time -->
                    <ng-container *ngSwitchCase="'Time'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <input pInputText type="time" [(ngModel)]="field.value" #CTime="ngModel" [ngModelOptions]="{standalone: true}" />

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || CTime.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Number -->
                    <ng-container *ngSwitchCase="'Number'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-inputNumber styleClass="w-100" class="w-100"
                                [(ngModel)]="field.value" #cnumber="ngModel"
                                [ngModelOptions]="{standalone: true}"
                                (keypress)="isNumberKey($event)">
                            </p-inputNumber>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && (!field.value && field.value!==0)
                                && (isSubmitted || cnumber.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Percentage -->
                    <ng-container *ngSwitchCase="'Percentage'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-inputNumber placeholder="%" styleClass="w-100" class="w-100"
                                [(ngModel)]="field.value" #CPercentage="ngModel"
                                [ngModelOptions]="{standalone: true}"
                                [minFractionDigits]="0" [maxFractionDigits]="(field?.customAttribute?.formControl?.maxLengthAfterDecimal||6)">
                            </p-inputNumber>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && (!field.value && field.value!==0)
                                && (isSubmitted || CPercentage.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Decimal -->
                    <ng-container *ngSwitchCase="'Decimal'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-inputNumber styleClass="w-100" class="w-100"
                                [(ngModel)]="field.value" #cdecimal="ngModel"
                                [ngModelOptions]="{standalone: true}"
                                [minFractionDigits]="0" [maxFractionDigits]="(field?.customAttribute?.formControl?.maxLengthAfterDecimal||6)"
                                (keypress)="isNumberKey($event)">
                            </p-inputNumber>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && (!field.value && field.value!==0)
                                && (isSubmitted || cdecimal.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Currency -->
                    <ng-container *ngSwitchCase="'Currency'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-inputNumber mode="decimal" [prefix]="field.currencySymbol ? field.currencySymbol.trim()+ ' ' : currencySymbol"
                                [placeholder]="field.currencySymbol ? field.currencySymbol.trim()+ ' ' : currencySymbol" [step]="1"
                                [(ngModel)]="field.value" #CCurrency="ngModel" [ngModelOptions]="{standalone: true}" styleClass="w-100"
                                class="w-100" [minFractionDigits]="0"
                                [maxFractionDigits]="(field?.customAttribute?.formControl?.maxLengthAfterDecimal||6)"
                                (keypress)="isNumberKey($event)">
                            </p-inputNumber>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && (!field.value && field.value!==0)
                                && (isSubmitted || CCurrency.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- User Lookup -->
                    <ng-container *ngSwitchCase="'UserLookup'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-dropdown [options]="usersList" [placeholder]="'Select ' + field.labelName"
                                #CUserLookup="ngModel" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                                optionLabel="name" optionValue="id" appendTo="body" [filter]="true"
                                [showClear]="true">
                            </p-dropdown>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value
                                && (isSubmitted || CUserLookup.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Dropdown List -->
                    <ng-container *ngSwitchCase="'DropDownList'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-dropdown [options]="field.customAttribute?.pickListValues" [placeholder]="'Select ' + field.labelName"
                                #cdd="ngModel" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" optionLabel="name"
                                dataKey="name" appendTo="body" [showClear]="!field.customAttribute?.isRequired">
                            </p-dropdown>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value
                                && (isSubmitted || cdd.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Multi Dropdown List -->
                    <ng-container *ngSwitchCase="'MultipleDropDownList'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-multiSelect [options]="field.customAttribute?.pickListValues" [placeholder]="'Select ' + field.labelName"
                                #cmdd="ngModel" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" optionLabel="name"
                                dataKey="name" appendTo="body">
                            </p-multiSelect>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || cmdd.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Checkbox -->
                    <ng-container *ngSwitchCase="'CheckBox'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <ng-container *ngFor="let opt of field.customAttribute?.pickListValues; let j = index;">
                                <p-checkbox (click)="field['touched']=true" [value]="opt.name" [name]="field.name" [(ngModel)]="opt.checked"
                                    [binary]="true" [ngModelOptions]="{standalone: true}" [required]="field.customAttribute?.isRequired"
                                    (onChange)="customAttributeService.changeCustomCheckbox($event, field, j, opt.name)" >
                                </p-checkbox> {{opt.name}}
                            </ng-container>

                            <div></div>
                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (field['touched'] || isSubmitted)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- File Upload -->
                    <ng-container *ngSwitchCase="'FileUpload'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                                <i class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipFile" tooltipPosition="top"></i>
                            </label>

                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose" [showUploadButton]="false"
                                [showCancelButton]="false" multiple="multiple" (onSelect)="onCustomUpload($event, field, 'any')">
                                <ng-template pTemplate="file"></ng-template>

                                <ng-template pTemplate="content">
                                    <ng-container *ngIf="field.customeAttachement?.length">
                                        <ng-container *ngFor="let profileImg of field.customeAttachement; let i = index;">
                                            <div class="p-fileupload-row" *ngIf="profileImg">
                                                <button pButton icon="fa fa-download" class="p-button-link p-px-0 p-py-0"
                                                    (click)="downloadFile(profileImg.name, profileImg.content)">
                                                </button>
                                                <ng-container *ngIf="profileImg.name?.length>15 else splitImageName">
                                                    <div>
                                                        {{ profileImg.name.substring(0, 14) }}...
                                                    </div>
                                                </ng-container>
                                                <ng-template #splitImageName>
                                                    <div>
                                                        {{ profileImg.name }}
                                                    </div>
                                                </ng-template>
                                                <div>
                                                    {{ (profileImg.sizeInBytes /1024).toFixed(2) + 'KB' }}
                                                </div>
                                                <div>
                                                    <button icon="pi pi-times" pButton
                                                        (click)="removeImg(i, field)" type="button">
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </p-fileUpload>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired
                                && !field.customeAttachement?.length && (isSubmitted || field['touched'])"
                                [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Picture -->
                    <ng-container *ngSwitchCase="'Picture'">
                        <div class="p-col-12 p-lg-6 p-mt-2 p-mb-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                                <i class="pi pi-exclamation-circle p-ml-1" [escape]="false" [pTooltip]="multiLineTooltipPicture" tooltipPosition="top"></i>
                            </label>

                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose" accept="image/*"
                                [showUploadButton]="false" [showCancelButton]="false" multiple="multiple" (onSelect)="onCustomUpload($event, field, 'image');">
                                <ng-template pTemplate="file"></ng-template>

                                <ng-template pTemplate="content">
                                    <ng-container *ngIf="field.customeAttachement">
                                        <ng-container *ngFor="let profileImg of field.customeAttachement;
                                            let i = index;">
                                            <div class="p-fileupload-row">
                                                <button pButton icon="fa fa-download"
                                                    (click)="downloadFile(profileImg.name, profileImg.content)"
                                                    class="p-button-link p-px-0 p-py-0">
                                                </button>
                                                <ng-container *ngIf="profileImg.content &&
                                                    profileImg.content.startsWith('data')
                                                    else localImage">
                                                    <img src="{{profileImg.content}}" width="100"
                                                        alt="card" />
                                                </ng-container>
                                                <ng-template #localImage>
                                                    <img [src]="profileImg.attachment.location"
                                                        width="100" alt="card" />
                                                </ng-template>
                                                <ng-container *ngIf="profileImg.name?.length > 15
                                                    else splitImageName">
                                                    <div>
                                                        {{ profileImg.name.substring(0, 14)}}...
                                                    </div>
                                                </ng-container>
                                                <ng-template #splitImageName>
                                                    <div>
                                                        {{ profileImg.name }}
                                                    </div>
                                                </ng-template>
                                                <div>
                                                    {{ (profileImg.sizeInBytes / 1024).toFixed(2) + 'KB' }}
                                                </div>
                                                <div>
                                                    <button icon="pi pi-times" pButton type="button"
                                                        (click)="removeImg(i, field)">
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </p-fileUpload>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired
                                && !field.customeAttachement?.length && (isSubmitted || field['touched'])"
                                [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Radio Button -->
                    <ng-container *ngSwitchCase="'RadioButton'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <ng-container *ngFor="let opt of field.customAttribute.pickListValues; let j = index;">
                                <p-radioButton (click)="field['touched']=true" [value]="opt.name" name="value" [(ngModel)]="field.value"
                                    [ngModelOptions]="{standalone: true}">
                                </p-radioButton>&nbsp;{{opt.name}}
                            </ng-container>

                            <div></div>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value?.length
                                && (isSubmitted || field['touched'])" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Date Picker -->
                    <ng-container *ngSwitchCase="'DatePicker'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-calendar appendTo="body" [monthNavigator]="true" #cdt="ngModel" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                                dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false" [(ngModel)]="field.value"
                                [ngModelOptions]="{standalone: true}" styleClass="w-100">
                            </p-calendar>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value
                                && (isSubmitted || cdt.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Date Time Picker -->
                    <ng-container *ngSwitchCase="'DateTimePicker'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-calendar appendTo="body" [monthNavigator]="true" #cdt="ngModel" [yearNavigator]="true" placeholder="mm/dd/yyyy hh:mm a"
                                dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="true" [hourFormat]="12" [(ngModel)]="field.value"
                                [ngModelOptions]="{standalone: true}" styleClass="w-100">
                            </p-calendar>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value
                                && (isSubmitted || cdt.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Rating -->
                    <ng-container *ngSwitchCase="'Rating'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-rating [cancel]="false" [(ngModel)]="field.value" #crt="ngModel" [ngModelOptions]="{standalone: true}">
                            </p-rating>

                            <small id="error-help" class="custom-fields-error-{{tabIndex}} p-invalid" *ngIf="field.customAttribute?.isRequired && !field.value
                                && (isSubmitted || crt.touched)" [class.details-error]="tabIndex === 1">
                                {{ field.labelName }} is required
                            </small>
                        </div>
                    </ng-container>

                    <!-- Toggle Button -->
                    <ng-container *ngSwitchCase="'ToggleButton'">
                        <div class="p-col-12 p-lg-6 p-mb-2 p-mt-2">
                            <label class="p-mb-2">
                                {{ field.labelName }}
                                <span style="color: red;" *ngIf="field.customAttribute?.isRequired">*</span>
                                @if(field.description){
                                    <i class="pi pi-info-circle p-mr-2 p-mb-1 info-icon-tooltip"
                                        pTooltip="{{field.description}}"
                                        tooltipPosition="top">
                                    </i>
                                }
                            </label>

                            <p-toggleButton class="p-mb-2" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" iconPos="right"
                                onLabel="{{ field.labelName }}" offLabel="{{ field.labelName }}" [onIcon]="'pi pi-check'"
                                [offIcon]="'pi pi-times'" class="vertical-middle">
                            </p-toggleButton>
                        </div>
                    </ng-container>

                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
